import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconLetterA = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11 5a3 3 0 0 0-3 3v4h8V8a3 3 0 0 0-3-3zm7 3a5 5 0 0 0-5-5h-2a5 5 0 0 0-5 5v12a1 1 0 1 0 2 0v-6h8v6a1 1 0 1 0 2 0z"
            clipRule="evenodd"
        />
    </svg>
);
